import { BaseComponent } from './../../../../shared/Components/base/base.component';
import { PagingService } from './../../../../shared/Services/PagingService';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { EmailContactService } from '../../services/emailContactService';
import { EmailContact } from '../../models/EmailContact';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-email.contact',
  templateUrl: './email.contact.component.html',
  styleUrls: ['./email.contact.component.scss'],
})
export class EmailContactComponent extends BaseComponent implements OnInit {
  emailContact: EmailContact;
  constructor(
    public service: EmailContactService,
    public route: Router,
    public paging: PagingService,
    private toast: NbToastrService,
  ) {
    super(route, service, paging, '');
    this.emailContact = {} as EmailContact;
  }

  ngOnInit() {
    this.service.getData('').subscribe((res) => {
      this.emailContact = res;
    });
  }

  update() {
    this.service.put(this.emailContact.id, this.emailContact).subscribe(
      (res) => {
        this.toast.show('تم تحديث بيانات البريد بنجاح', '', { status: 'success', duration: 3000 });
      },
      (error) => {
        this.toast.show('خطأ في تحديث بيانات البريد', '', { status: 'danger', duration: 3000 });
      },
    );
  }
}
